export var LiveStreamingStateWrapTestIds = /*#__PURE__*/function (LiveStreamingStateWrapTestIds) {
  LiveStreamingStateWrapTestIds["AVATAR_BADGE_IS_LIVE"] = "live-streaming-state-avatar-badge-is-live";
  LiveStreamingStateWrapTestIds["AVATAR_BADGE_WAS_LIVE"] = "live-streaming-state-avatar-badge-was-live";
  return LiveStreamingStateWrapTestIds;
}({});